import { Dashboard } from "./Dashboard";
import { useContractor } from "../hooks";
import { useParams } from "react-router-dom";

export function ContractorDashboard() {
  const { id } = useParams();
  const contractor = useContractor(id);

  if (contractor.isLoading) {
    return <p>Loading...</p>;
  } else if (contractor.isError) {
    return <p>An unknown error occurred.</p>;
  } else if (contractor.isSuccess) {
    return <Dashboard contractor={contractor.data} />;
  } else {
    return <p>Contractor not found.</p>;
  }
}
